import get from 'lodash/get';
import gql from 'graphql-tag';

const WORK_TYPE = 'Work';
const WORK_FRAGMENT_NAME = 'WorkFieldsForWhitelist';
const WORK_FRAGMENT = gql`
  fragment ${WORK_FRAGMENT_NAME} on ${WORK_TYPE} {
    matureContent
  }
`;

export const workIsSafe = work => get(work, 'matureContent') === false;

const INVENTORY_ITEM_TYPE = 'ihs_InventoryItemsItem';
const INVENTORY_ITEM_FRAGMENT_NAME = 'InventoryItemFieldsForWhitelist';
const INVENTORY_ITEM_FRAGMENT = gql`
  fragment ${INVENTORY_ITEM_FRAGMENT_NAME} on ${INVENTORY_ITEM_TYPE} {
    work(locale: $locale) {
      matureContent
    }
    price {
      amount
      currency
    }
  }
`;

export const inventoryItemIsSafe = inventoryItem =>
  !!(
    get(inventoryItem, 'work') &&
    !get(inventoryItem, 'work.matureContent') &&
    !!get(inventoryItem, 'price')
  );

export const createChecker = filters => item => {
  const { __typename: type } = item;
  const fn = filters[type];

  if (typeof fn === 'function') return fn(item);

  return false;
};

export const objectIsSafe = createChecker({
  [WORK_TYPE]: workIsSafe,
  [INVENTORY_ITEM_TYPE]: inventoryItemIsSafe
});

export const fragments = [
  {
    type: WORK_TYPE,
    name: WORK_FRAGMENT_NAME,
    fragment: WORK_FRAGMENT
  },
  {
    type: INVENTORY_ITEM_TYPE,
    name: INVENTORY_ITEM_FRAGMENT_NAME,
    fragment: INVENTORY_ITEM_FRAGMENT
  }
];

export default objectIsSafe;
